import { $$ } from '../../utilities/QuerySelectors.js';

class FreeArticleNotice {
    constructor(container) {
        if (!container) {
            return;
        }

        this.container = container;
        this.toggleButton = this.container.querySelector('.free-article-notice__toggle');
        this.disclaimer = this.container.querySelector('.free-article-notice__disclaimer');

        if (!this.toggleButton || !this.disclaimer) {
            return;
        }

        this.toggleButton.addEventListener('click', () => this.toggle());
    }

    toggle() {
        const isHidden = this.disclaimer.hasAttribute('hidden');
        if (isHidden) {
            this.disclaimer.removeAttribute('hidden');
        } else {
            this.disclaimer.setAttribute('hidden', '');
        }
        this.updateAria();
    }

    updateAria() {
        const expanded = !this.disclaimer.hasAttribute('hidden');
        this.toggleButton.setAttribute('aria-expanded', expanded.toString());
    }
}

export function initFreeArticleNotice() {
    const containers = $$('.free-article-notice');
    if (!containers.length) {
        return;
    }

    containers.forEach((container) => new FreeArticleNotice(container));
}
